import { useState } from "react";
import Ticker from "./components/Ticker";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LatestSection from "./components/LatestSection";
import ColumnsSection from "./components/ColumnsSection";
import DepthSection from "./components/DepthSection";
import SpotlightSection from "./components/SpotlightSection";
import FaqSection from "./components/FaqSection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  const [activeCat, setActiveCat] = useState("all");

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Ticker />
      <Navbar />
      <main>
        <Hero />
        <LatestSection activeCat={activeCat} onCatChange={setActiveCat} />
        <ColumnsSection onSelect={setActiveCat} />
        <DepthSection />
        <SpotlightSection />
        <FaqSection />
      </main>
      <FooterSection />
    </div>
  );
}